// Shared pagination contract — the single source of truth for the API's
// collection endpoints (apps/api list-query.ts), the portals' list state
// (portal-lib list-controls.ts) and the pagination footer (ui
// pagination-controls.tsx). Change page-size rules here, nowhere else.

export const DEFAULT_PER_PAGE = 20;
export const MAX_PER_PAGE = 100;
export const PER_PAGE_OPTIONS = [10, 20, 50, 100];

/** Pages in a result set (always at least 1 so "Page 1 of 1" renders). */
export function pageCount(total: number, perPage: number): number {
  return Math.max(Math.ceil(total / Math.max(perPage, 1)), 1);
}
